import { createFileRoute } from '@tanstack/react-router';
import { choicesReadGuard } from '@bmwe/ui';
import { ChoiceTypeManagement } from '../../../features/choices/choiceTypeManagement';

export const Route = createFileRoute('/auswahlfelder/waehrungen/')({
  component: () => (
    <ChoiceTypeManagement
      choiceTypeKey="Currency"
      returnRoute="/auswahlfelder/currency"
    />
  ),
  beforeLoad: choicesReadGuard,
});

export const CurrenciesRoute = Route;
